import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { StatsCard } from "components/Card/StatsCard.jsx";
import { headersTitles } from "./AccountStatusVariables";

import { connect } from 'react-redux';
import { fetchAccountInfo } from 'reducers/account/accountActions'

class AccountStatusView extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.fetchAccountInfo();
  }

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col lg={4} sm={6} lgOffset={8}>
              <StatsCard
                bigIcon={<i className="pe-7s-cash text-success" />}
                statsText="Total"
                statsValue={this.props.account.balance + " Bs."}
              />
            </Col>
            <Col md={12}>
              <Card
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        {headersTitles.map((prop, key) => {
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.account.transactions.map((transaction, key) => {
                        return (
                          <tr key={key}>
                            <td>{transaction.date}</td>
                            <td>{transaction.type}</td>
                            <td>{transaction.description}</td>                            
                            <td className="text-right">{transaction.transactionType === "IN" ? transaction.amount : ""}</td>
                            <td className="text-right">{transaction.transactionType === "OUT" ? transaction.amount : ""}</td>
                            <td className="text-right">{transaction.partialBalance}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  account: state.account.info
});

export default connect(mapStateToProps, { fetchAccountInfo })(AccountStatusView);


// WEBPACK FOOTER //
// ./src/views/AccountStatus/AccountStatusView.jsx